import { Segmented } from "antd";

export type TeamTab = "members" | "pending";

export interface SegmentedControlProps {
  value: TeamTab;
  onChange: (value: TeamTab) => void;
  membersLabel: string;
  pendingLabel: string;
}

export function SegmentedControl({
  value,
  onChange,
  membersLabel,
  pendingLabel,
}: SegmentedControlProps) {
  return (
    <Segmented<TeamTab>
      value={value}
      size="medium"
      onChange={(v) => onChange(v as TeamTab)}
      // Wrap each label in a span carrying the presenter's existing
      // data-testid so automation tests (which target those ids) keep
      // working on the new tab UI. See AHA-42798.
      options={[
        {
          value: "members",
          label: <span data-testid="my-team-members-tab-button">{membersLabel}</span>,
        },
        {
          value: "pending",
          label: <span data-testid="my-team-invitations-tab-button">{pendingLabel}</span>,
        },
      ]}
    />
  );
}
